/**
 * NOTE
 *
 * We also have the ItemType enum in webapi-mytradera-generated.ts which
 * has different casing on Shop items.
 *
 * Be mindful about which one you use.
 */
enum ItemTypes {
    AUCTION = 'Auction',
    AUCTION_BIN = 'AuctionBin',
    PURE_BIN = 'PureBin',
    SHOP_ITEM = 'ShopItem',
}

export default ItemTypes;
